import {
  BellIcon,
  CalendarIcon,
  CoinsIcon,
  HistoryIcon,
  HomeIcon,
  MoonIcon,
  PawPrintIcon,
  TargetIcon,
  UsersIcon,
  LucideIcon,
} from 'lucide-react';
import { SettingsSection } from '../types/ui';

export const settingsSections: { id: SettingsSection; label: string; hint: string; icon: LucideIcon }[] = [
  { id: 'clani', label: 'Družina in člani', hint: 'Ime, člani, vloge, vabila', icon: UsersIcon },
  { id: 'naloge', label: 'Naloge in hišne kategorije', hint: 'Nosilci, vrednost, ponavljanje', icon: HomeIcon },
  { id: 'cilji', label: 'Osebni cilji in dejavnosti', hint: 'Branje, šport, instrumenti', icon: TargetIcon },
  { id: 'zivali', label: 'Živali in oskrba', hint: 'Skrbniki, bivališča, pogostosti', icon: PawPrintIcon },
  { id: 'tocke', label: 'Točke, žepnina in nagrade', hint: 'Kačing, žepnina, goodies, cenik', icon: CoinsIcon },
  { id: 'koledar', label: 'Koledar in zasebnost', hint: 'Povezani viri, vidnost', icon: CalendarIcon },
  { id: 'vecer', label: 'Večerni režim in izjeme', hint: 'Ure, naprave', icon: MoonIcon },
  { id: 'moduli', label: 'Opomniki in moduli', hint: 'Kaj družina uporablja', icon: BellIcon },
  { id: 'zgodovina', label: 'Zgodovina sprememb', hint: 'Kdo, kaj, od kdaj', icon: HistoryIcon },
];
